import { styled, DialogContent as DialogContentMui } from '@mui/material';

export const DialogContent = styled(DialogContentMui)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
